import { dark } from '@space-lib/styles/themes'
import type { ThemeMode } from '@space-lib/styles/themes/enum'

import ArrowDark from '@space-shell/assets/images/collapseArrowDark.svg'
import ArrowLight from '@space-shell/assets/images/collapseArrowLight.svg'

const useCustomAssests = () => {
  const customAssets = (theme: ThemeMode) => {
    document.documentElement.style.setProperty(
      '--hc-collapse-item-opener-background',
      `url(${theme === dark.title ? ArrowDark : ArrowLight})`
    )
  }

  return { customAssets }
}

export default useCustomAssests
